import config from "../config/config";
const path = (route) => `${config.BaseURL}${route}`;

export const Urls = {
    userLogin: path("/users/login"),
    materials: path('/filters/grouped-by-brand'),
    flashdashboard  : path('/filters/grouped-by-brand'),
    materialData: path('/brandwisedata/compare-prices'),
    materialDropDown: path('/materials'),
    graphMaterial: path('/brandwisedata/brandComparisonWithSize'),
    availabilty: path('/brandwisedata/availability'),
    productTypes: path('/productSizeTypes'),
    productSize: path('/sizes'),
    speedTrend : path('/brandwisedata/brandComparisonSpeedTrend'),
    priceTrend : path('/brandwisedata/brandComparisonPriceTrend'),
}